/****   http.js   ****/
// 导入封装好的axios实例
import request from './request'
import axios from 'axios'
const preUrl="http://localhost:8100/"
//创建一个新的axios实例
const uploadService = axios.create({
    baseURL: "http://cmres.zhixiaoyuan.net:8888",
    //设置超时时间，超过该时间就不会发起请求
    timeout:15000
})

const http ={
    getDownLoadUrl(){
        return "https://www.zjrbl.com:8443/file/"
    },
    /**
     * methods: 请求
     * @param url 请求地址
     * @param params 请求参数
     */
    get(url,params){

        const config = {
            method: 'get',
            url:preUrl+url,
            isToken:false
        }
        if(params) config.params = params
        return request(config)
    },

    getToken(url,params){
        const config = {
            method: 'get',
            url:preUrl+url,
            isToken:true
        }
        if(params) config.params = params
        return request(config)
    },
    post(url,params){
        const config = {
            method: 'post',
            url:preUrl+url,
            isToken:false
        }
        if(params) config.data = params
        return request(config)
    },

    postToken(url,params){
        const config = {
            method: 'post',
            url:preUrl+url,
            isToken:true
        }
        if(params) config.data = params
        return request(config)
    },
    put(url,params){
        const config = {
            method: 'put',
            url:url
        }
        if(params) config.params = params
        return request(config)
    },
    delete(url,params){
        const config = {
            method: 'delete',
            url:url
        }
        if(params) config.params = params
        return request(config)
    }
}
//导出
export default http